import React from 'react';
import CreatableSelect from 'react-select/creatable';
import { customStylesDark, customStylesLight } from '../../../Utils/Utility';
const CreatableSelectCommon = (props) => {
    const {placeholderText, carrierNameHandler, createHandler, ref, defaultValue, isLoading, carrierOptions, name,
        formatCreateLabelText, loadingMessageText, creatableTheme } = props; 
    
    return ( 
        <CreatableSelect
            className="basic-single"
            classNamePrefix="select"
            placeholder={placeholderText}
            styles={creatableTheme === 'dark' ? customStylesDark: customStylesLight}
            onInputChange={carrierNameHandler}
            onChange={createHandler}
            ref={ref}
            defaultValue={defaultValue}
            isLoading={isLoading}
            isClearable={true}
            isSearchable={true}
            options={carrierOptions}
            name={name}
            formatCreateLabel={formatCreateLabelText}
            loadingMessage={loadingMessageText}
        />
     );
}
 
export default CreatableSelectCommon;